import { useContext, useState } from "react";
import { UserContext } from "../../context/UserProvider";
import { OverlayTrigger, Tooltip, Dropdown } from "react-bootstrap";
import { FaUserCircle, FaSignOutAlt, FaUser, FaEdit, FaUsers, FaBox } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { DataContex } from "../../context/DataContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import styles from "./NavUser.module.scss";

const MySwal = withReactContent(Swal);

export const NavUser = () => {
  const { user } = useContext(UserContext);
  const { paths } = useContext(DataContex);
  const navigate = useNavigate();
  const auth = getAuth();
  const [avatarError, setAvatarError] = useState(false);

  // Función para validar si la URL es válida y no vacía
  const isValidUrl = (url) => {
    if (!url || typeof url !== 'string' || url.trim() === '') return false;
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (error) {
      MySwal.fire({
        title: 'Error',
        text: 'Error al cerrar sesión: ' + error.message,
        icon: 'error'
      });
    }
  };

  // Usar avatarURL de Firebase Storage si existe, si no usar photoURL
  const avatarURL = user?.avatarURL || user?.photoURL;
  const initial =
    (user?.displayName && user.displayName[0]) ||
    (user?.email && user.email[0]) ||
    "?";

  // Definir rutas protegidas y nivel mínimo requerido
  const rutasProtegidas = [
    { label: "ABM Materiales", path: `/${paths.abm}`, nivel: 9, icon: <FaBox /> },
    { label: "Crear Material", path: `/${paths.materialCreate}`, nivel: 9, icon: <FaEdit /> },
    { label: "Editar Material", path: `/${paths.editMaterial}`, nivel: 9, icon: <FaEdit /> },
    { label: "ABM Usuarios", path: "/abm-usuarios", nivel: 9, icon: <FaUsers /> },
  ];

  // Si no está logueado
  if (!user) {
    return (
      <OverlayTrigger placement="bottom" overlay={
        <Tooltip id="tooltip-user">Iniciar sesión</Tooltip>
      }>
        <div 
          className={styles.navUserPlaceholder}
          onClick={() => navigate('/login')}
        >
          <FaUserCircle size={32} />
        </div>
      </OverlayTrigger>
    );
  }

  // Mostrar imagen solo si la URL es válida y no hubo error al cargar
  const showAvatar = isValidUrl(avatarURL) && !avatarError;

  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        as="div"
        id="dropdown-user"
        className={styles.dropdownToggle}
      >
        {showAvatar ? (
          <img
            src={avatarURL}
            alt="avatar"
            className={styles.navUserAvatar}
            onError={() => setAvatarError(true)}
          />
        ) : (
          <div className={styles.navUserInitial}>
            {initial.toUpperCase()}
          </div>
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.dropdownMenu}>
        <div className={styles.userInfo}>
          <div className={styles.userName}>{user.displayName || 'Usuario'}</div>
          <div className={styles.userEmail}>{user.email}</div>
          {user.roles && user.roles.length > 0 && (
            <div className={styles.userRoles}>
              {user.roles.map((role, index) => (
                <span key={index} className={styles.roleBadge}>
                  {role}
                </span>
              ))}
            </div>
          )}
        </div>
        <Dropdown.Divider />
        <Dropdown.Item 
          onClick={() => navigate('/perfil')}
          className={styles.dropdownItem}
        >
          <FaUser className={styles.menuIcon} />
          Ver perfil
        </Dropdown.Item>
        {rutasProtegidas
          .filter(r => user.nivelSuscripcion >= r.nivel && r.label !== "Editar Material")
          .map(ruta => (
            <Dropdown.Item 
              key={ruta.path} 
              onClick={() => navigate(ruta.path)}
              className={styles.dropdownItem}
            >
              {ruta.icon}
              {ruta.label}
            </Dropdown.Item>
          ))}
        <Dropdown.Divider />
        <Dropdown.Item 
          onClick={handleLogout} 
          className={`${styles.dropdownItem} ${styles.logoutItem}`}
        >
          <FaSignOutAlt className={styles.menuIcon} />
          Cerrar sesión
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}; 